import { define, html } from "hybrids";

export interface VBroadcastPeopleReadMore {
  reveal: boolean;
  enabled: boolean;
}

function open(host: VBroadcastPeopleReadMore) {
  host.reveal = true;
}

function close(host: VBroadcastPeopleReadMore) {
  host.reveal = false;
}

function enable(host: VBroadcastPeopleReadMore, event: Event) {
  const target = event.target as HTMLSlotElement;
  if (target.assignedElements().length > 0) {
    host.enabled = true;
  }
}

export default define<VBroadcastPeopleReadMore>({
  tag: "v-broadcast-people-read-more",
  reveal: false,
  enabled: false,
  render: ({ reveal, enabled }) => html`
    <div id="content" class="${{ reveal }}">
      <slot></slot>
      ${enabled &&
        !reveal &&
        html`<v-ui-text ygutter="1">
          <v-ui-button
            variant="inline"
            type="underline"
            onclick="${open}"
            name="Read more"
          ></v-ui-button>
        </v-ui-text>`}
    </div>
    <slot
      id="more"
      name="more"
      class="${{ reveal }}"
      onslotchange=${enable}
    ></slot>
    ${enabled &&
      reveal &&
      html`<v-ui-text ygutter="1">
        <v-ui-button
          variant="inline"
          type="underline"
          onclick="${close}"
          name="Read less"
        ></v-ui-button>
    </v-ui-text>`}
  `.css`
    #content.reveal {
      display: none;
    }

    #more[name="more"]:not(.reveal) {
      display: none;
    }

    slot::slotted(*:not(:last-child)) {
      margin-bottom: var(--v-ui-text-gutter);
    }
  `,
});
